import React from 'react';
import './HeroSecondary.css';

export const HeroSecondary = ({ title, bgImage }) => {
  return <div className="hero-secondary" style={{ backgroundImage: `url(${bgImage})` }}>
    <h1 dangerouslySetInnerHTML={{__html: title}}></h1>
  </div>;
};
